import axios from "axios";
import {JwtUtils} from "./auth/JwtUtils";
import {ApiError} from "./errors/ApiError";
import {CommonUtils} from "./CommonUtils";
import {useParams} from "react-router-dom";
import {useAuthenticationContext} from "./auth/AuthenticationContext";

export namespace HttpInterceptors {
    import getToken = JwtUtils.getToken;
    import getCurrentLanguage = CommonUtils.getCurrentLanguage;

    export function configureInterceptor() {
        axios.interceptors.request.use((config) => {
            const token = getToken();
            const lang = getCurrentLanguage();
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
            // Only set Content-Type to application/json if the data is NOT FormData
            if (!(config.data instanceof FormData)) {
                config.headers["Content-Type"] = "application/json";
            }
            config.headers["langid"] = lang.Id;
            return config;
        }, function (error) {
            return Promise.reject(error);
        })
        //Set up an interceptor to handle 401 errors globally
        axios.interceptors.response.use(
            response => {
                // Check if response matches ApiResponseDto structure and has error messages
                if (
                    response.data &&
                    typeof response.data.IsSuccess === "boolean" &&
                    !response.data.IsSuccess
                    // Array.isArray(response.data.ErrorMessages) &&
                    // response.data.ErrorMessages.length > 0
                ) {
                    // Throw custom ApiError with relevant details
                    throw new ApiError(
                        "API responded with errors",
                        response.data.ErrorMessages,
                        response
                    );
                }
                // If the response is successful, simply return the response
                return response;
            },
            error => {
                if (error.response && error.response.status === 404) {
                    throw new ApiError(
                        "API responded with error 404",
                        ["Requested resource doesn't exist"],
                        null
                    );
                }
                if (error.response && error.response.status === 401) {
                    // Handle 401 Unauthorized globally
                    //window.location.href = '/login'; // Redirect to login page
                    throw new ApiError(
                        "API responded with error 401",
                        ["Unauthorized"],
                        null
                    );
                }
                if (error.code && error.code == "ERR_NETWORK") {
                    // Handle 401 Unauthorized globally
                    //window.location.href = '/login'; // Redirect to login page
                    throw new ApiError("", ["Network error"], null);
                }
                // Return any other error to be caught in catch blocks
                return Promise.reject(error);
            }
        );

    }
}